import {
  HeadingText,
  AuthorizedBadge,
  Button,
  Sheet,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import PropTypes from 'prop-types'

const ViewPerm = (props) => {
  const { party, permissions } = props
  const apiUsername = party.apiUsername
  const Organization = party.Organization
  const grantedPermissions = party.grantedPermissions
  const baseClass =
    props.windowWidth <= props.mobileScreenSize
      ? 'tpp_dialogMobile'
      : 'tpp_dialog'

  const renderPermissions = () => {
    let descriptivePerms = []
    for (let index = 0; index < grantedPermissions.length; index++) {
      const element = permissions.find(
        (c) => c.name === grantedPermissions[index],
      )
      descriptivePerms = [...descriptivePerms, element]
    }

    return descriptivePerms.map((perm, index) => {
      return (
        <div className="tppView_List" id={`v${index}`} key={index}>
          <AuthorizedBadge size="xs" />
          <div id={`view_${perm.name}`} className="view_perm">
            <Message id={`thirdPartyPerm.${perm.text_ref}`} />
          </div>
        </div>
      )
    })
  }

  return (
    <Sheet
      skipFormFocus
      className={baseClass}
      noPadding
      showLogo
      isOpen={props.isViewOpen}
      containerClassName="tpp_sheetContainer"
      wrapperClassName="tpp_sheetWrapper"
      onCloseComplete={() => {
        props.setViewOpen({ type: 'view', value: false })
        props.setToChange({})
      }}
      title={<Message id="thirdPartyPerm.grantedPermissions" />}
      hideTitle
      footerContents={
        <Button
          id="viewOK"
          data-pa-click="viewPermsBtn"
          onClick={() => {
            props.setViewOpen({ type: 'view', value: false })
            props.setToChange({})
          }}
        >
          <Message id="thirdPartyPerm.OK" />
        </Button>
      }
      footerAlign="center"
    >
      <div>
        <HeadingText
          tabIndex={0}
          // level={1}
          className="tppView_Heading view_heading"
        >
          <Message id="thirdPartyPerm.grantedPermissions" />
        </HeadingText>
      </div>
      <div className="view_subHeadingUpper">
        <div className="view_subHeading">
          <p>
            <Message id="thirdPartyPerm.thirdPartyUsername" />:{' '}
            <strong id="viewApiUsername">{apiUsername}</strong>
          </p>
        </div>
        <div className="view_subHeading">
          <p>
            <Message id="thirdPartyPerm.organization" />:{' '}
            <strong id="viewOrganization">{Organization}</strong>
          </p>
        </div>
      </div>
      <div className="view_body">{renderPermissions()}</div>
    </Sheet>
  )
}

ViewPerm.propTypes = {
  party: PropTypes.object,
  permissions: PropTypes.array,
  isViewOpen: PropTypes.any,
  setViewOpen: PropTypes.func,
  setToChange: PropTypes.func,
  windowWidth: PropTypes.any,
  mobileScreenSize: PropTypes.any,
}

export default ViewPerm
